<template>
    <modal name="registration-modal"
           :height="modalHeight"
           class="account-popup-area visible"
           @before-open="beforeOpen"
           @before-close="beforeClose"
           :clickToClose="false"
           :width="600"
           :adaptive="true"
           :shiftY="0.5"
           v-cloak>
        <div class="details-profile-box">
            <div class="account-popup signon-prompt-popup">

                <span @click="$modal.hide('registration-modal')" class="close-popup new-close-icon">
                    <i class="la la-close"></i>
                    <span class="svg-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"/></svg>
                    </span>
                </span>

                <h3><b>Registrazione</b></h3>

                <!-- Text above form -->
                <div class="login-info-text" style="color: #FFC000; padding: 15px 0;">
                    <span>Se eri un utente esistente di Tennisprofy, vai su Login e puoi usare la stessa Email e Password lì. Se non sei sicuro o non te li ricordi, vai a password dimenticata.</span>
                </div>

                <form v-on:submit.prevent="onSubmit" name="registerForm" id="registerForm">
                    <input type="hidden" v-model="user.type" />

                    <div class="select-user" :class="{ error: errors.type }">
                        <div class="mb-2"><small>Seleziona chi sei</small></div>

                        <div class="reg-buttons-container">
                            <div class="select-user-container" :class="{'active': user.type=='m'}">
                                <span class="select-user-item user-type-professional" :class="{'active': user.type=='m'}" v-on:click="setType('m'); resetErrors(); clearErrors( $event );">Professionista</span>
                                <div class="info-icon-text">
                                    <i @click="setType('m')" class="ps-2 las la-info-circle tool-info text-muted"  data-bs-placement="top" data-bs-toggle="tooltip" data-bs-html="true" title="Maestro di tennis/padel,<br>Sparring partner,<br>Preparatore fisico,<br>Incordatore, Giocatore di campionati a squadre" ></i>
                                </div>
                            </div>

                            <div class="select-user-container" :class="{'active': user.type=='s'}">
                                <span class="select-user-item user-type-professional" :class="{'active': user.type=='s'}" v-on:click="setType('s'); resetErrors(); clearErrors( $event );">Struttura</span>
                                <div class="info-icon-text">
                                    <i @click="setType('s')" class="ps-2 las la-info-circle tool-info text-muted"  data-bs-placement="top" data-bs-toggle="tooltip" data-bs-html="true" title="Tennis/padel club o accademia,<br>Struttura ricettiva (Hotel, Resort, Camping o Summer camps),<br>Agenzia di animazione"></i>
                                </div>
                            </div>
                            
                            
                        </div>

                        <div class="mt-1 text-center" style="min-height: auto; text-align: center;">
                            <span class="error-msg-wrapper text-center" style="min-height: auto; text-align: center;">
                                <span class="error-msg" style="min-height: auto; text-align: center;" v-if="errors.type">{{ errors.type }}</span>
                            </span>
                        </div>
                    </div>

                    <!-- <div class="select-user-text">
                        <div class="info-icon-text">
                            <i class="las la-info-circle tool-info text-muted  "  data-bs-placement="bottom" data-bs-toggle="tooltip" title="[TPJ TOOLTIP - Professional details]"></i>
                        </div>
                        <div class="info-icon-text">
                            <i class="las la-info-circle tool-info text-muted "  data-bs-placement="bottom" data-bs-toggle="tooltip" title="[TPJ TOOLTIP - Professional details]"></i>
                        </div>
                    </div> -->

                    


                    <div class="clearfix"></div>

       
                    <div class="field-grid2">
                        <div class="field-grid-col">
                            <div class="field-wrapper" v-if="user.type=='m' || user.type=='s'" >

                                <!-- <div v-if="user.type=='m'" class="cfield" :class="{ error: errors.name }">
                                    <input type="text" placeholder="Nome" data-cons-subject="first_name" v-model="user.name" v-on:focus="resetErrors()" />
                                    <i class="la la-user"></i>
                                </div> -->
                                <div class="pf-field user-surname-field">
                                    <div class="pf-field floating-label-input" :class="{'error': this.errors['name']}">
                                        <input data-lpignore='true' type="text" placeholder="" data-cons-subject="first_name" name="firstname" id="firstname" v-model="user.name" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                                        <label class="floating-label" for="firstname">Nome</label>
                                    </div>
                                </div>

                                <span class="error-msg-wrapper" style="min-height: 35px;">
                                    <span class="error-msg" v-if="errors.name">{{ errors.name }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="field-grid-col">
                                <!-- <div v-if="user.type=='m'" class="cfield" :class="{ error: errors.surname }">
                                    <input type="text" placeholder="Cognome" data-cons-subject="last_name" v-model="user.surname" v-on:focus="resetErrors()" />
                                    <i class="la la-user"></i>
                                </div> -->
                                <div class="field-wrapper" v-if="user.type=='m' || user.type=='s'" >
                
                                    <div class="pf-field user-surname-field">
                                        <div class="pf-field floating-label-input" :class="{'error': this.errors['surname']}">
                                            <input data-lpignore='true' type="text" placeholder="" data-cons-subject="last_name" name="surname" id="surname" v-model="user.surname" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                                            <label class="floating-label" for="surname">Cognome</label>
                                        </div>
                                    </div>

                                    <span class="error-msg-wrapper" style="min-height: 35px;">
                                        <span class="error-msg" v-if="errors.surname">{{ errors.surname }}</span>
                                    </span>
                                </div>
                        </div>
                    </div>




                    <!-- <div v-if="user.type=='s'" class="cfield" :class="{ error: errors.businessname }">
                        <input type="text" placeholder="Struttura Nome" data-cons-subject="business" v-model="user.businessname" v-on:focus="resetErrors()" />
                        <i class="la la-user"></i>
                    </div> -->

                    <div class="field-wrapper" v-if="user.type=='s'" >
    

                        <div class="pf-field user-businessname-field">
                            <div class="pf-field floating-label-input" :class="{'error': this.errors['businessname']}">
                                <input autocomplete="false" data-lpignore='true' type="text" placeholder="" data-cons-subject="business" name="businessname" id="businessname" v-model="user.signup_business_name" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                                <label class="floating-label" for="businessname">Struttura nome</label>
                            </div>
                        </div>

                        <span class="error-msg-wrapper" style="min-height: 35px;">
                            <span class="error-msg" v-if="errors.businessname">{{ errors.businessname }}</span>
                        </span>
                    </div>

                    <div class="field-wrapper"  v-if="user.type !== ''">
                        <!-- <div class="cfield">
                            <input type="text" placeholder="Email" v-model="user.email" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                            <i class="la la-user"></i>
                        </div> -->

                        <div class="pf-field user-email-field">
                            <div class="pf-field floating-label-input" :class="{'error': this.errors['email']}">
                                <input type="text" name="email" placeholder="" data-cons-subject="email" id="useremail" v-model="user.email" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                                <label class="floating-label" for="useremail">Email</label>
                                
                            </div>
                        </div>

                        <span class="error-msg-wrapper" style="min-height: 35px;">
                            <span class="error-msg" v-if="errors.email">{{ errors.email }}</span>
                        </span>
                    </div>

                    <!-- <div class="cfield" :class="{ error: errors.email }">
                        <input type="email" placeholder="Email" data-cons-subject="email" v-model="user.email" v-on:focus="resetErrors()" />
                        <i class="la la-envelope-o"></i>
                    </div> -->


                    <!-- PASSWORDS FIELD -->

                    <div class="field-wrapper"  v-if="user.type !== ''">
                        <div class="pf-field user-email-field">
                            <div class="pf-field floating-label-input" :class="{'error': this.errors['password']}">
                                <input :type="!showPassword ? 'password' : 'text'" data-cons-exclude placeholder="" id="userpassword" v-model="user.password" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors" />
                                <label class="floating-label" for="userpassword">Password</label>
                            </div>
                        </div>
                        <span class="error-msg-wrapper">
                            <span class="error-msg" v-if="errors.password">{{ errors.password }}</span>
                        </span>
                    </div>

                    <div class="field-wrapper user-confirm"  v-if="user.type !== ''">
                        <div class="pf-field user-email-field">
                            <div class="pf-field floating-label-input" :class="{'error': this.errors['password_confirmation']}">
                                <input :type="!showPassword ? 'password' : 'text'" data-cons-exclude placeholder="" id="userpassword_confirmation" v-model="user.password_confirmation" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors" />
                                <label class="floating-label" for="userpassword_confirmation">Conferma password</label>
                            </div>
                        </div>
                        <span class="error-msg-wrapper no-height-error">
                            <span class="error-msg" v-if="errors.password_confirmation">{{ errors.password_confirmation }}</span>
                        </span>
                    </div>

                    <div class="show-password-wrapper py-2 mb-4" v-if="user.type !== ''">
                        <div class="show-pw-check">
                            <p class="remember-label">
                                <input type="checkbox" name="showpassword" value="1" id="showpassword" v-model="showPassword"><label for="showpassword">Mostra password</label>
                            </p>
                        </div>
                    </div>

                    <!-- <div class="cfield" :class="{ error: errors.password }">
                        <input type="password" placeholder="Password" data-cons-exclude v-model="user.password" v-on:focus="resetErrors()" />
                        <i class="la la-key"></i>
                    </div>
                    <div class="cfield" :class="{ error: errors.password_confirmation }">
                        <input type="password" placeholder="Conferma Password" data-cons-exclude v-model="user.password_confirmation" v-on:focus="resetErrors()" />
                        <i class="la la-key"></i>
                    </div> -->




                    <div class="consent-box" v-if="user.type !== ''">
                        <input type="checkbox" name="promo_consent" v-model="user.promo_consent" id="promo_consent" :value="true">
                        <label for="promo_consent">
                            <small>Voglio ricevere novità, opportunità e comunicazioni da TennisPadelJobs. (facoltativo)</small>
                        </label>
                    </div>

                    <div class="consent-box"  v-if="user.type !== ''">
                        <input type="checkbox" name="conditions" v-model="user.conditions" data-cons-preference="conditions" id="conditions"  v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors" :value="1" />
                        <label for="conditions" :class="{ error: errors.conditions }">
                            <small v-html="$checkTermsText"></small>
                            <span class="error-msg-wrapper" style="min-height: auto;" v-if="errors.conditions">
                                <span class="error-msg" v-if="errors.conditions">{{ errors.conditions }}</span>
                            </span>
                        </label>

                    </div>
                    
                    <button type="submit" v-if="user.type !== ''"  class="signin-submit-btn" :disabled="(formSaving || is_errors || fieldsNotPopulated) ? true : null" :class="{'btn-in-progress': formSaving, 'btn-processed': formSaved  }">
                        <span>Registrati</span>
                    </button>

                    
                </form>
            </div>
        </div>
    </modal>
</template>



<script>

    export default {
        name: "registration-modal",
        props: {
            type: undefined, 
            click_to_close: true,
        },

        computed: {
            fieldsNotPopulated(){

                let fieldsPending = true;


                if ( this.user.type == 'm' ) {

                    if ( this.user.name && this.user.surname && this.user.email && this.user.password && this.user.password_confirmation && this.user.conditions ) {
                        fieldsPending = false;
                    }

                } else if ( this.user.type == 's' ) {
                    if ( this.user.signup_business_name && this.user.email && this.user.password && this.user.password_confirmation && this.user.conditions ) {
                        fieldsPending = false;
                    }
                }

                return fieldsPending;
            }
        },

        data () {
            return {
                style: "",
                modalHeight: 'auto',
                user: {name: "", surname: "", signup_business_name: "",email: "", password: "", conditions: "", type: "", password_confirmation: "", promo_consent: false},
                errors:  {type: false, name: false, surname: false,businessname: false, email: false, password: false, conditions: false},
                redirect: "",

  

                emailValidated: false,
                passwordValidated: false,
                formSaving: false,
                formSaved: false,
                is_errors: false,
                showPassword: false,
            }
        },
        methods: {

            runIubScript(){

                (function (w, d) {
                    var loader = function () {
                    var s = d.createElement("script"),
                        tag = d.getElementsByTagName("script")[0];
                    s.src = "https://cdn.iubenda.com/iubenda.js";
                    tag.parentNode.insertBefore(s, tag);
                    };
                    if (w.addEventListener) {
                    w.addEventListener("load", loader, false);
                    } else if (w.attachEvent) {
                    w.attachEvent("onload", loader);
                    } else {
                    w.onload = loader;
                    }
                })(window, document);
            },

            clearErrors( $event, submit = false ){

                const regexEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                // const regexPassword = /^(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?`~]{8,20}$/;
                // const regexPassword = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?`~])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?`~]{8,20}$/;
                // const regexPassword = /^(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?`~])[A-Za-z\d!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?`~]{8,20}$/;
                // const regexPassword = /^(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?~]{8,20}$/;
                const regexPassword = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?~]{8,20}$/;
                

                const nameRegex = /^[A-Za-z\u00C0-\u024F' -]{2,50}$/;
                const businessNameRegex = /^[A-Za-z\u00C0-\u024F0-9\s.,\-\'&]{1,80}$/;
                let istouchevent = $event?.type=='change' || ($event?.type == 'keyup' && ['Tab'].indexOf( $event?.key ) < 0) || $event?.type == 'blur' ;

                console.log('Error validation...');

                this.$forceUpdate();


                let emailValidated = regexEmail.test(this.user.email);
                let passwordValidated = regexPassword.test(this.user.password);
                

                console.log('email validated: ', emailValidated, this.user.email);
                console.log('password validated: ', passwordValidated, this.user.password);


                // Validate email
                if ( !emailValidated || (submit && !emailValidated) ) {
                    if ( istouchevent && this.user.email == '' && $event?.target.name == 'email' ||  ( submit && !emailValidated )) {
                        this.errors['email'] = "Inserisci";
                    } else if ( this.user.email  ) {
                        this.errors['email'] = "Inserisci una email valida";
                    } else {
                    }
                } else {
                    this.errors['email'] = false;
                }


                // Validate User name
                if (this.user.type == 'm' || this.user.type == 's') {

                    let firstNameValidated = nameRegex.test(this.user.name);
                    let lastNameValidated = nameRegex.test(this.user.surname);

                    if ( this.user.name && !firstNameValidated || (submit && !firstNameValidated ) ) {
                        this.errors['name'] = '2-50 caratteri, solo lettere e trattini';
                    } else if ( istouchevent && this.user.name == '' && $event?.target.name == 'firstname' ) {
                        this.errors['name'] = "Inserisci";
                    } else if ( this.user.name && firstNameValidated ) {
                        this.errors['name'] = false;
                    } else {}

                    if ( this.user.surname && !lastNameValidated || (submit && !lastNameValidated) ) {
                        this.errors['surname'] = '2-50 caratteri, solo lettere e trattini';
                    } else if ( istouchevent && this.user.surname == '' && $event?.target.name == 'surname' ) {
                        this.errors['surname'] = "Inserisci";
                    } else if ( this.user.name && lastNameValidated ) {
                        this.errors['surname'] = false;
                    } else {}
                } else {
                    this.errors['name'] = false;
                    this.errors['surname'] = false;
                }

                // Business name
                if (this.user.type == 's') {
                    let businessNameValidated = businessNameRegex.test(this.user.signup_business_name);

                    if ( this.user.signup_business_name && !businessNameValidated || (submit && !businessNameValidated ) ) {
                        this.errors['businessname'] = 'Inserisci un nome della struttura valido';
                    } else if ( istouchevent && this.user.signup_business_name == '' && $event?.target.name == 'businessname' ) {
                        this.errors['businessname'] = "Inserisci";
                    } else if ( this.user.signup_business_name && businessNameValidated ) {
                        this.errors['businessname'] = false;
                    } else {}
                } else {
                    this.errors['businessname'] = false;
                }

                


                // Validate password
                if ( this.user.password && !passwordValidated || (submit && !passwordValidated ) ) {
                    this.errors['password'] = "Almeno una lettera, almeno un numero, min 8 e max 20 caratteri";
                } else {
                    this.errors['password'] = false;
                    this.errors['password_confirmation'] = false;
                }


                // Password confirmation validation
                if ( passwordValidated && this.user.password_confirmation || submit ) {
                    if ( this.user.password == this.user.password_confirmation ) {
                        this.errors['password_confirmation'] = false;
                    } else {
                        this.errors['password_confirmation'] = "La password non corrisponde";
                    }
                } else {
                    this.errors['password_confirmation'] = false;
                }


                //  Conditions
                if ( this.user.conditions ) {
                    this.errors['conditions'] = false;
                } else if ( (istouchevent && $event?.target.name == "conditions" ) || submit )  {
                    this.errors['conditions'] = "Si prega di accettare per procedere";
                } else {

                }

                //  User type
                if ( this.user.type ) {
                    this.errors['type'] = false;
                } else if ( submit && !this.user.type ) {
                    this.errors['type'] = "Seleziona un tipo di utente";
                } else {

                }
                

       
  
                for (var k in this.errors) {
                    if (this.errors[k]) {
                        this.is_errors = true;
                        // window.scroll(0, 0);
                        return
                    }
                    this.is_errors = false;
                }




            },

            onSubmit( $event ) {
                this.clearErrors( $event, true );

                var haveErrors = false
                for (var key in this.errors) {
                    haveErrors = haveErrors || this.errors[key]
                }

                if (!haveErrors) {
                    // form saving
                    this.formSaving = true; 

                    this.$apiClient.registerUser(this.user).then(response => {
                        if (response.data && response.data.status) {

                            this.formSaving = false; 
                            this.formSaved = true; 

                            if (response.data.status == "error") {
                                var messages = response.data.message;
                                var errorMessage = "";

                                Object.keys(messages).forEach((key) => {
                                    this.errors[key] = true;
                                    errorMessage += messages[key].join("\n")+"\n";
                                    this.errors[key] = messages[key].join("\n")+"\n";
                                });

                                if (errorMessage) {
                                    alert(errorMessage);
                                }
                            } else {

                                // Successful registration
                                if (typeof gtag === "function") {
                                        gtag("event", "sign_up", {
                                            method: "Website"
                                        });
                                    }

                                    window.location = this.redirect;

                            }
                        }else{
                            window.location = this.redirect;
                        }
                    }).catch(error => {
                        this.formSaving = false; 
                        this.formSaved = true; 
                        alert('Ops! Si é verificato un errore');
                        console.log(error)
                    });
                }
            },

            resetErrors() {
                this.errors = {type: false, name: false, surname: false, businessname: "", email: false, password: false, conditions: false}
            },
            setType(type) {

                let _this = this;

                

                if (type) {
                    this.user.type = type;
                    this.appBaseUrl = import.meta.env.VITE_APP_URL;
                    this.appCallUrl = this.appBaseUrl;

                    if (type == 'm' || type == 'master') {
                        this.redirect = this.appCallUrl+"/private/registration/professional";
                    } else {
                        this.redirect = this.appCallUrl+"/private/registration/business";
                    }

                    // Set the scroll
                    window.setTimeout(function(){
                        let registrationModal = document.querySelector('[data-modal="registration-modal"]');
                        if ( registrationModal ) {
                            // registrationModal.scroll({top: 300, behaviour: 'smooth'});
                        }

                        // _this.runIubScript();
                    }, 100);
                }
            },
            beforeOpen(event){
                $('html').addClass('no-scroll');
                this.user = {name: "", surname: "", businessname:"", email: "", password: "", conditions: "", type: "", password_confirmation: "", promo_consent: false};
                this.resetErrors();
                this.redirect = "";

                window.setTimeout(function(){
                    jQuery("#registerForm [data-bs-toggle='tooltip']").tooltip() ;           
                }, 300);


                if (event.params)
                    this.setType(event.params.type);


                // Testing
                /*
                this.user.name = "Deepak";
                this.user.surname = "Test";
                this.user.email = "deepak.kamat+120@velotechnologies.com";
                this.user.password = "Deepakkam@1";
                this.user.password_confirmation = "Deepakkam@1";
                this.user.type = "m";
                this.user.conditions = 1;
                */
            },
            beforeClose(event) {
                this.cnd = null;
                this.master_data = null;
                $('html').removeClass('no-scroll');
            }
        }
    }
</script>

<style scoped>
    .visible {
        display: block;
    }
</style>
